// AuthContext.jsx
import React, { createContext, useState, useEffect, useContext } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';

export const AuthContext = createContext(undefined);

export const useAuth = () => {
    return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [nome, setNome] = useState(null);

    useEffect(() => {
        const token = sessionStorage.getItem('token');
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setIsAuthenticated(true);
                setNome(decoded.name);
            } catch (error) {
                console.error('Invalid token', error);
                logout();
            }
        }
    }, []);

    const login = (token) => {
        try {
            const decoded = jwtDecode(token);
            sessionStorage.setItem('token', token);
            setIsAuthenticated(true);
            setNome(decoded.name);
        } catch (error) {
            console.error('Failed to decode token', error);
            logout();
        }
    };

    const logout = () => {
        sessionStorage.removeItem('token');
        setIsAuthenticated(false);
        setNome(null);
    };

    return (
        <AuthContext.Provider value={{ isAuthenticated, nome, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
